<naas-alerts id="alert_content"></naas-alerts>
<naas-school-banner></naas-school-banner>
<naas-container-selector></naas-container-selector>
